import React, { useEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import useMedia from "use-media";
import commonUtil from '../../../common/commonUtil';
import CommonUtil from '../../../common/commonUtil';
import CommonValidation from '../../../common/commonValidation';
import { getPlanList } from "../../../const/RTCC";
import Const from '../../../const/RTCC/Const';
import MessageConst from '../../../const/RTCC/messageConst';
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import "../../../resources/RTCC/css/common/radio_box_style.css";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from '../../atoms/RTCC/button';
import { Label } from '../../atoms/RTCC/label';
import { ErrorMassage } from '../../molecules/RTCC/errorMassage';
import { LabelInputForm } from "../../molecules/RTCC/labelInputForm";
import { ModalOptionForm } from '../../molecules/RTCC/modalOptionForm';
import { PullDownOptionForm } from '../../molecules/RTCC/pullDownOptionForm';
import './../../../resources/RTCC/css/reservation/reservation.css';

const SideSearchFormContainer = (props) => {
    const { data,
        state,
        login,
        checkIn,
        checkOut,
        group,
        roomHome,
        roomOverseas,
        dispRoom,
        human,
        dispHuman,
        startTime,
        area,
        country,
        city,
        stayInfo,
        age,
        keyWord,
        course,
        searchParam,
        setCourse,
        setGroup,
        setRoomHome,
        setRoomOverseas,
        setHuman,
        setKeyWord,
        setStayInfo,
        kaiinken,
        setKaiinken,
        setCheckIn,
        setSearchResult,
        setSearchParam,
        setBeforeAreaId,
        setBeforeCountryId,
        setPopupData,
        setPopupMessage,

        onClickOpenReservationPopupWindow,
        onClickOpenCheckListWindow,
        onClickOpenCalendarWindow,
        onChange,
        handlePlanList,
        handleSaveSearchCondition,
        displaySwitch,
        displaySwitchTab,
        createAgeCountList } = props;

    const { getHoliday } = GetPublicHoliday();

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [roomNumber, setRoomNumber] = useState("1");
    const [dispRoomReq, setDispRoomReq] = useState("1");
    const [dispRoomNew, setDispRoomNew] = useState("1");
    const [stayReq, setStayReq] = useState([]);
    const [humanReq, setHumanReq] = useState([]);
    const [roomReq, setRoomReq] = useState([]);
    const room = displaySwitch ? roomHome : roomOverseas;
    const [errorMessage, setErrorMessage] = useState([]);
    const [errorFlg, setErrorFlg] = useState(false);
    const [flgList, setFlgList] = useState({});
    const store = useStore();
    const adultNumList = state.adultNumList ? state.adultNumList : [{ id: "1", value: "1人" }];
    const chlidNumList = state.chlidNumList ? state.chlidNumList : [{ id: "0", value: "0人" }];

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    useEffect(() => {
        displaySearchConditions();
    }, []);

    useEffect(() => {
        if (state.popupMode == "savedSearch" && !state.reservationPopup) {
            displaySearchConditions();
        }
    }, [state.reservationPopup]);

    // 検索条件初期表示
    const displaySearchConditions = () => {
        let newStayInfoList = [];
        if (stayInfo) {
            newStayInfoList = stayInfo.map(value => Object.assign({}, {
                adultNum: value.adultNum,
                childNum: value.childNum,
                ageList: value.ageList ? value.ageList.slice() : [],
                errorFlg: false
            }));
        }
        setStayReq(newStayInfoList);
        if (displaySwitch) {
            if (roomHome) {
                setRoomReq(roomHome.map(value => Object.assign({}, value)));
            }
        } else {
            if (roomOverseas) {
                setRoomReq(roomOverseas.map(value => Object.assign({}, value)));
            }
        }
        setDispRoomReq(dispRoom);
        setDispRoomNew(dispRoom);
        for (let i in room) {
            if (room[i].selected === true) {
                setRoomNumber(room[i].id);
            }
        }
        createAgeCountList(Const.MAX_CAPACITY);
    }

    // 検索ボタン押下時
    const onClickSearch = () => {
        let errorMessageBox = [];
        let errorFlg = false;
        let flgList = {
            errInputWord: false,
            errArea: false,
            errCountry: false,
            errCity: false
        }

        store.dispatch({ type: "DISP_ROOM", payload: { dispRoom: dispRoomReq } });
        setStayInfo(stayReq);
        if(displaySwitch){
            setRoomHome(roomReq);
        }else{
            setRoomOverseas(roomReq);
        }
        // エリア
        let areaId = null;
        for (var i in area) {
            if (area[i].checked === true) {
                areaId = areaId + (areaId == null ? null : ",");
                areaId = areaId + area[i].value;
            }
        }
        if (areaId == null) {
            flgList.errArea = true;
        }
        // 国
        let countryId = null;
        for (var i in country) {
            if (country[i].checked === true) {
                countryId = countryId + (countryId == null ? null : ",");
                countryId = countryId + country[i].value;
            }
        }
        if (countryId == null) {
            flgList.errCountry = true;
        }
        // 都市
        let cityIdList = [];
        if(countryId !== null){
            for (var i in city) {
                if (city[i].checked === true) {
                    cityIdList.push(city[i].value);
                }
            }
        }
        if (cityIdList.length == 0) {
            errorMessageBox.push(MessageConst.DESTINATION_ERROR);
            errorFlg = true;
            flgList.errCity = true;
        }
        // 室数
        let vacancyNum = 1;
        room.forEach((data) => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });
        let reqStayInfo = [];
        let humanErrorFlg = false;
        stayReq.map((value, humanIndex) => {
            let ageList = value.ageList;
            let childAge = "";
            ageList.map((value, index) => {
                childAge = index == 0 ? value : childAge + "," + value;
            })
            if ((Number(value.adultNum) + Number(value.childNum)) > Const.MAX_CAPACITY) {
                value.errorFlg = true;
                humanErrorFlg = true;
                errorFlg = true;
            } else {
                value.errorFlg = false;
            }
            reqStayInfo.push({
                roomCount: humanIndex + 1,
                adultNum: Number(value.adultNum),
                childNum: Number(value.childNum),
                childAge: childAge
            })
        })
        if (humanErrorFlg) {
            errorMessageBox.push(MessageConst.HUMAN_NUM_ERROR);
        }

        // チェックイン
        const startDate = CommonUtil.getStringFromDate(new Date(checkIn), "yyyy-MM-dd");

        // チェックアウト
        const endDate = CommonUtil.getStringFromDate(new Date(checkOut), "yyyy-MM-dd");

        const exclusiveList = document.getElementsByName("exclusive");
        let lcFlg = 0;
        exclusiveList.forEach((exclusive) => {
            if (exclusive.checked === true) {
                lcFlg = exclusive.value;
            }
        })
        let inputWord = keyWord == null ? "" : keyWord;
        if (!CommonValidation.Require(inputWord) && CommonValidation.OverMinLength(inputWord, 1) && CommonValidation.OverMinKanji(inputWord, 1)) {
            errorMessageBox.push(MessageConst.KEYWORD_ERROR);
            errorFlg = true;
            flgList.errInputWord = true;
        }
        if (errorFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
        } else {
            const param = {
                areaId: areaId,
                countryId: countryId,
                cityIdList: cityIdList,
                requestVacancyNum: vacancyNum,
                stayInfo: reqStayInfo,
                startDate: startDate,
                endDate: endDate,
                inputWord: inputWord,
                lcFlg: "0",
                detail: "",
                subDetail: "",
                overseasHomeFlg: searchParam.searchParam.overseasHomeFlg,
            }
            setSearchParam(param)
            common.doPost(getPlanList, param, afterGetPlanList);
        }
        setErrorMessage(errorMessageBox);
        setErrorFlg(errorFlg);
        setFlgList(flgList);
    }
    const afterGetPlanList = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            handlePlanList(commonUtil.sortFee(data.hotelList));
        } else {
            handlePlanList([]);
        }
    }

    // チェックイン日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(checkIn);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }
    // チェックアウト日表示処理
    const getDateToString2 = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkOutDate = new Date(checkOut);
        const y = checkOutDate.getFullYear();
        const m = checkOutDate.getMonth() + 1;
        const d = checkOutDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkOutDate.getDay()]})`;
    }

    // 選択した組数をstoreに保存
    const onChangeRoom = (e) => {
        let selected = e.target.value;
        setDispRoomReq(selected);
        roomReq.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
                setDispRoomNew(data.id);
            } else {
                data.selected = false;
            }
        })
        setRoomReq(roomReq);
        let addNum = selected - stayReq.length
        let newList = stayReq;
        if (addNum < 0) {
            newList = newList.filter((value, index) => {
                return index < selected;
            })

        } else {
            for (let i = 0; i < addNum; i++) {
                newList.push({
                    adultNum: dispHuman,
                    childNum: "0",
                    ageList: []
                })
            }
        }
        setStayReq(newList);
    };

    const onChangeAdultNum = (e, target) => {
        let adultNum = e.target.value;
        let newList = [];
        if (adultNum < 1) {
            return;
        }
        stayReq.map((value, humanIndex) => {
            newList.push(value);
            if (humanIndex == target) {
                newList[humanIndex].adultNum = adultNum;
            }
        })
        setStayReq(newList);
    }
    const onChangeChildNum = (e, target) => {
        let childNum = e.target.value;
        if (childNum > Const.MAX_CAPACITY) {
            childNum = Const.MAX_CAPACITY;
        }
        let newList = [];
        stayReq.map((value, humanIndex) => {
            newList.push(value);
            if (humanIndex == target) {
                newList[humanIndex].childNum = childNum;
                let ageList = newList[humanIndex].ageList ? newList[humanIndex].ageList : [];
                let addNum = childNum - ageList.length;
                if (addNum < 0) {
                    ageList = ageList.filter((value, ageIndex) => {
                        return ageIndex < childNum;
                    })
                } else {
                    for (let i = 0; i < addNum; i++) {
                        ageList.push("0");
                    }
                }
                newList[humanIndex].ageList = ageList;
            }
        })
        setStayReq(newList);
    }
    const onChangeAge = (e, targetHuman, targetAge) => {
        let newStayInfo = [];
        stayReq.map((value, humanIndex) => {
            newStayInfo.push(value);
            if (humanIndex == targetHuman) {
                newStayInfo[humanIndex].ageList.map((age, ageIndex) => {
                    if (ageIndex == targetAge) {
                        newStayInfo[humanIndex].ageList[ageIndex] = e.target.value;
                    }
                })
            }
        })
        setStayReq(newStayInfo);
    }

    // エリア選択
    const getAreaText = () => {
        let dispText = store.getState().dispArea ? store.getState().dispArea : "選択なし";
        return dispText;
    }
    // 国選択
    const getCountryText = () => {
        let dispText = store.getState().dispCountry ? store.getState().dispCountry : "選択なし";
        return dispText;
    }
    // ClassName(国)
    const getCountryClassName = () => {
        let dispText = store.getState().dispArea ? store.getState().dispArea : "選択なし";
        if(dispText === "選択なし"){
            return "nonPopupButton";
        }
        return "popupButton";
    }
    // onClick(国)
    const getCountryOnClick = () => {
        let dispText = store.getState().dispArea ? store.getState().dispArea : "選択なし";
        if(dispText === "選択なし"){
            return "";
        }
        return onClickOpenCheckListWindow;
    }
    // 都市選択
    const getCityText = () => {
        let countryDispText = store.getState().dispCountry ? store.getState().dispCountry : "選択なし";
        if(countryDispText === "選択なし"){
            return "選択なし";
        }else {
            let cityDispText = store.getState().dispCity ? store.getState().dispCity : "選択なし";
            return cityDispText;
        }
    }
    // ClassName(都市)
    const getCityClassName = () => {
        let dispText = store.getState().dispCountry ? store.getState().dispCountry : "選択なし";
        if(dispText === "選択なし"){
            return "nonPopupButton";
        }
        return "popupButton";
    }
    // onClick(都市)
    const getCityOnClick = () => {
        let dispText = store.getState().dispCountry ? store.getState().dispCountry : "選択なし";
        if(dispText === "選択なし"){
            return "";
        }
        return onClickOpenCheckListWindow;
    }

    return (
        <div className="container">
            <div className="searchConditions">
                <div style={errorFlg ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} >
                    <ErrorMassage data={errorMessage} />
                </div>
                <div className="search">
                    {/* <LabelInputForm
                        label={"キーワード検索"}
                        id="keyWord"
                        placeholder="例）ワイキキホテル"
                        value={keyWord}
                        className={flgList.errInputWord ? "popupButtonKeywordErr" : "popupButtonKeyword"}
                        onChange={onChangeKeyWord}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                        tabIndex="1"
                    /> */}
                    <ModalOptionForm
                        title={"目的地"}
                        id={"areaModal"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel"
                        className={flgList.errArea ? "popupButtonErr" : "popupButton"}
                        onClick={displaySwitch ? onClickOpenCheckListWindow : null }
                        text={getAreaText()}
                        tabIndex="2" />
                    <ModalOptionForm
                        id={"countryModal"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel"
                        className={flgList.errCountry ? "popupButtonErr" : "popupButton" && getCountryClassName()}
                        onClick={displaySwitch ? getCountryOnClick() : null}
                        text={getCountryText()}
                        tabIndex="3" />
                    <ModalOptionForm
                        id={"cityModal"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel"
                        className={flgList.errCity ? "popupButtonErr" : "popupButton" && getCityClassName()}
                        onClick={getCityOnClick()}
                        text={getCityText()}
                        tabIndex="4" />
                    <div className="popupWrap">
                    </div>
                    <ModalOptionForm
                        id={"checkIn"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel" title={"チェックイン"}
                        className="popupButton"
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString()}
                        tabIndex="5"
                    />
                    <ModalOptionForm
                        id={"checkOut"}
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel" title={"チェックアウト"}
                        className="popupButton"
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString2()}
                        tabIndex="6"
                    />
                    <PullDownOptionForm
                        wrapClassName="popupWrapLong"
                        labelClassName="popupLabel"
                        title={"室数"}
                        className="pullModalButton"
                        data={roomReq}
                        state={dispRoomNew}
                        onChange={onChangeRoom}
                        id={"roomCount"}
                        tabIndex="7"
                    />
                    {stayReq.map((value, humanIndex) =>
                        <div key={"stayInfo" + humanIndex} className='inputStayInfo'>
                            <Label
                                label={"客室" + (humanIndex + 1)}
                                className="popupLabel"
                            />
                            <PullDownOptionForm
                                wrapClassName="stayInfoSideWrap"
                                labelClassName="popupLabel"
                                className={value.errorFlg ? "pullModalButtonErr" : "pullModalButton"}
                                title={"大人(18歳以上)"}
                                data={adultNumList}
                                id={"adult" + humanIndex}
                                state={value.adultNum}
                                onChange={(e) => onChangeAdultNum(e, humanIndex)}
                                tabIndex="9"
                            />
                            <PullDownOptionForm
                                wrapClassName="stayInfoSideWrap"
                                labelClassName="popupLabel"
                                className={value.errorFlg ? "pullModalButtonErr" : "pullModalButton"}
                                title={"こども(0～17歳)"}
                                data={chlidNumList}
                                id={"child" + humanIndex}
                                state={value.childNum}
                                onChange={(e) => onChangeChildNum(e, humanIndex)}
                                tabIndex="10"
                            />
                            <Label
                                label="チェックイン時の年齢"
                                className={value.ageList.length > 0 ? "popupLabel" : "hiddenItem"}
                            />
                            <div className='inputAge'>
                                {value.ageList.map((ageValue, ageIndex) =>

                                    <PullDownOptionForm
                                        key={"age" + humanIndex + "_" + ageIndex}
                                        wrapClassName="stayInfoWrap"
                                        labelClassName="popupLabel"
                                        className="pullModalButton"
                                        title={"お子様" + (ageIndex + 1)}
                                        data={age}
                                        id={"age" + ageIndex}
                                        state={ageValue}
                                        onChange={(e) => onChangeAge(e, humanIndex, ageIndex)}
                                        tabIndex="11"
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    <div className="onlyPlanWrap">
                        {/* <div className="onlyPlanReservationResult">
                            <input
                                type="radio"
                                id="onlyLuxury1"
                                name="exclusive"
                                className="onlyPlanRadio"
                                onChange={onChange} />
                            <label className="onlyPlanReservationResultLabel">ラグジュアリーコレクションのみ</label>
                        </div>
                        <div className="onlyPlanReservationResult">
                            <input
                                type="radio"
                                id="onlyLuxury2"
                                name="exclusive"
                                className="onlyPlanRadio"
                                onChange={onChange} />
                            <label className="onlyPlanReservationResultLabel">通常プランのみ</label>
                        </div> */}
                    </div>
                </div>

                <div className="searchbox">
                    <Button buttonText="検 索" className="btnReservationSide" onClick={onClickSearch} buttonClassName="serachBtnText" tabIndex="12" />
                </div>
                <div style={{ marginTop: "25px" }}>
                    <Button
                        className="saveSearchConditionBtn"
                        onClick={handleSaveSearchCondition}
                        buttonText="この検索条件を保存"
                        buttonClassName="conditionBtnText"
                        tabIndex="13"
                    />
                    <Button
                        className="searchConditionBtn"
                        onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}
                        buttonText="保存した検索条件"
                        buttonClassName="conditionBtnText"
                        tabIndex="14"
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,

        group: state.group,
        human: state.human,
        age: state.age,
        dispHuman: state.dispHuman,
        keyWord: state.keyWord,
        roomHome: state.roomHome,
        roomOverseas: state.roomOverseas,
        dispRoom: state.dispRoom,
        stayInfo: state.stayInfo,

        startTime: state.startTime,
        area: state.area,
        country: state.country,
        city: state.city,
        course: state.course,
        kaiinken: state.kaiinken,
        searchParam: state.searchParam,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },

        setKeyWord: (item) => {
            dispatch({ type: "KEYWORD", payload: { keyWord: item } })
        },
        setRoomHome: (item) => {
            dispatch({ type: "ROOM_HOME", payload: { roomHome: item } })
        },
        setRoomOverseas: (item) => {
            dispatch({ type: "ROOM_OVERSEAS", payload: { roomOverseas: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setStayInfo: (item) => {
            dispatch({ type: "STAY_INFO", payload: { stayInfo: item } })
        },
        setSearchParam: (item) => {
            dispatch({ type: "SEARCH_PARAM", payload: { searchParam: item } })
        },

        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        }
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(SideSearchFormContainer);